































































































/* eslint-disable */
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import ProvisaoStore from '@/store/Provisao'

@Component

export default class ComponentProvisaoDadosIniciais extends Vue {
  @Prop(Boolean) show

  get showProvisaoInformacoesAdicionais(): Boolean {
    return ProvisaoStore.getters.DIALOG_INFORMACOES_ADICIONAIS
  }

  set showProvisaoInformacoesAdicionais(newValue) {
    ProvisaoStore.commit('DIALOG_INFORMACOES_ADICIONAIS', newValue)
  }

  get getAplicarTipoAtendimento() {
    return ProvisaoStore.getters.APLICAR_TIPO_ATENDIMENTO
  }

  get getAplicarAcomodacao() {
    return ProvisaoStore.getters.APLICAR_ACOMODACAO
  }

  get tipoAtendimento() {
    return ProvisaoStore.getters.TIPO_ATENDIMENTO
  }

  set tipoAtendimento(selected) {
    ProvisaoStore.dispatch('SET_TIPO_ATENDIMENTO', selected)
  }

  get tipoAcomodacao() {
    return ProvisaoStore.getters.TIPO_ACOMODACAO
  }

  set tipoAcomodacao(selected) {
    ProvisaoStore.dispatch('SET_TIPO_ACOMODACAO', selected)
  }

  get provisao() {
    return ProvisaoStore.getters.PROVISAO
  }

  get procedimentos() {
    return ProvisaoStore.getters.PROCEDIMENTOS
  }

  @Emit('close')
  close() {
    ProvisaoStore.dispatch('CALCULADORA_PROVISAO')
    ProvisaoStore.dispatch('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR','success')

    if((this.procedimentos.some(p => p.aplicaUrgencia) && this.tipoAtendimento !== '' && this.tipoAtendimento !== undefined) &&
       (this.procedimentos.some(p => p.aplicaAcomodacao) && this.tipoAcomodacao !== '' && this.tipoAcomodacao !== undefined)) {
        ProvisaoStore.dispatch('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', false)
       }
      else{
        if(!this.procedimentos.some(p => p.aplicaUrgencia) || !this.procedimentos.some(p => p.aplicaAcomodacao)) {
          ProvisaoStore.dispatch('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', false)
        }
        else{
          ProvisaoStore.dispatch('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', true)
        }
      }
  }
}
